import { styled } from '@mui/material/styles';
import { AiBackground } from 'src/components/ai/AiBackground';
import { AiStars } from 'src/components/ai/AiStars';

const Wrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
}));

const StyledStars = styled(AiStars)(({ theme }) => ({
  zIndex: 2,
}));

const StyledAiBackground = styled(AiBackground)(({ theme }) => ({
  position: 'absolute',
  zIndex: 0,
  inset: 0,
}));

type AiLoadingProps = {
  className?: string;
};

export const AiLoading = ({ className }: AiLoadingProps) => (
  <Wrapper className={className}>
    <StyledAiBackground />
    <StyledStars className="stars" />
  </Wrapper>
);
